import { produce } from "immer";
import {
  FETCH_HISTORYS,
  FETCH_HISTORYS_FAILURE,
  FETCH_HISTORYS_SUCCESS,
} from "./constants";

export const initialState = {
  isFetchingHistory: false,
  historyList: [],
};

const HistoryReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_HISTORYS:
        draft.isFetchingHistory = true;
        draft.historyList = [];
        break;
      case FETCH_HISTORYS_SUCCESS:
        draft.isFetchingHistory = false;
        draft.historyList = action.payload;
        break;
      case FETCH_HISTORYS_FAILURE:
        draft.isFetchingHistory = false;
        draft.historyList = [];
        break;

      default:
        return state;
    }
  });

export default HistoryReducer;
